import { User as DynamoUser } from '../DynamoTypes';
import { AvatarChange, GetAvatarResponse } from './sharedTypes';
import { UTMParameters } from '../HubspotTypes';
import { MedicalProfileNotificationType, DeliveryType } from '../NotificationTypes';
import { LambdaInvocationTypes } from '..';

export type CreateUserBody = { user: Omit<DynamoUser, 'userId'> } & { avatar: AvatarChange };
export type CreateUserResponse = DynamoUser;

// Which app build sent the request. A sibling of `user` rather than a field on it: the update route
// spreads `body.user` straight onto the stored User, and this is request context, not user data.
export type AppClientInfo = { platform?: string; appVersion?: string };

export type UpdateUserBody = CreateUserBody & { clientInfo?: AppClientInfo };
export type UpdateUserResponse = DynamoUser;

export type User = DynamoUser;

export type MeResponse = DynamoUser & { email: string; isTestUser: boolean; promptRegistration: boolean };

export type GetAvatarUrlResponse = GetAvatarResponse | null;

export type UpdateUserPromoCodeBody = { promoCode: string };

export type RecordUserUTMParametersRequest = UTMParameters;

export type UserMedicalProfilePreferences = {
    medicalProfileId: string;
    preferences: {
        [N in MedicalProfileNotificationType]: DeliveryType[];
    };
};

export type UserPreferences = {
    medicalProfilePreferences: UserMedicalProfilePreferences[];
};

export type GetUserPreferencesResponse = UserPreferences;

export type UpsertUserPreferencesRequest = UserPreferences;
export type UpsertUserPreferencesResponse = UserPreferences;

export type UserPlatformRequest = {
    platform: string;
};

export type AdminListOrganizationsResponse = {
    organizations: LambdaInvocationTypes.AdminListedOrganization[];
};

export type AdminToggleOrganizationPaidStatus = {
    organizationId: string;
    isPaid: boolean;
};
